/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFillFilePdf = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M5.691 18.11c.385-.449 1.097-.915 1.603-1.186-.304.637-.733 1.315-1.087 1.683-.719.747-1.11.2-.516-.497zm12.306-3.038c-.706-.014-1.352-.365-1.821-.702.682-.06 1.258-.058 1.658.004.918.143.988.714.163.698zm-5.326-1.635c-.404.1-1.754.436-2.391.662l.011-.026c.098-.22.774-1.743 1.025-2.413.315.578 1.237 1.599 1.374 1.75l.016.018a6.17 6.17 0 0 1-.035.009zm-1.503-5.549c-.201-.618-.373-1.626-.258-2.252.125-.687.537-.644.651-.052.115.592-.167 1.801-.393 2.304z" />
        <path d="M22 2.5H2v19h20zM8.381 14.777a66.678 66.678 0 0 0 2.036-4.744 11.307 11.307 0 0 1-.93-3.373c-.498-4.378 4.169-4.053 3.459.025-.136.782-.461 1.878-.967 3.264.734 1.39 1.698 2.436 2.466 3.127 1.05-.178 2.544-.361 3.595-.197 2.794.436 2.44 3.704-.043 3.704-1.299 0-2.925-1.075-3.943-1.902-1.56.305-3.227.774-4.661 1.312-.458.936-1.073 2.128-1.62 2.967-2.287 3.5-5.3.273-2.877-2.156.692-.693 1.864-1.375 3.485-2.027z" />
      </g>
    </g>
  </Icon>
);
export { SvgFillFilePdf as FillFilePdf };
